/* KobiStore — tema Shopify. Sem dependências. */
(function () {
  "use strict";
  var K = window.KOBI || {};
  // Garante as rotas da Shopify mesmo que alguma venha vazia no tema.
  (function () {
    var r = K.routes || {}, root = typeof r.root === "string" && r.root ? r.root : "/";
    if (root.slice(-1) !== "/") root += "/";
    var def = { root: root, cart: root + "cart", cartAdd: root + "cart/add", cartChange: root + "cart/change", cartUpdate: root + "cart/update", search: root + "search", predictive: root + "search/suggest" };
    Object.keys(def).forEach(function (k) { if (typeof r[k] !== "string" || !r[k] || r[k] === "undefined" || r[k] === "null") r[k] = def[k]; });
    K.routes = r;
  })();
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  var digits = function (s) { return String(s || "").replace(/\D/g, ""); };

  /* ---------- Dinheiro ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    cents = parseInt(cents, 10) || 0;
    format = format || K.moneyFormat || "R$ {{amount_with_comma_separator}}";
    function fmt(n, dec, th, ds) {
      var fixed = (n / 100).toFixed(dec).split(".");
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return whole + (fixed[1] ? ds + fixed[1] : "");
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount": return fmt(cents, 2, ",", ".");
        case "amount_no_decimals": return fmt(cents, 0, ",", ".");
        case "amount_no_decimals_with_comma_separator": return fmt(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator": return fmt(cents, 2, "'", ".");
        case "amount_with_space_separator": return fmt(cents, 2, " ", ",");
        default: return fmt(cents, 2, ".", ",");
      }
    }).replace(/<[^>]*>/g, "");
  }
  K.formatMoney = formatMoney;

  /* ---------- Avisos ---------- */
  function toast(msg, bad) {
    var box = $("#toasts"); if (!box) return;
    var t = document.createElement("div");
    t.className = "toast" + (bad ? " bad" : "");
    t.setAttribute("role", bad ? "alert" : "status");
    t.textContent = msg;
    box.appendChild(t);
    setTimeout(function () { t.style.transition = "opacity .3s"; t.style.opacity = "0"; setTimeout(function () { t.remove(); }, 320); }, 3400);
  }

  /* ---------- Gavetas ---------- */
  var overlay = $("#overlay");
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add("on"); el.setAttribute("aria-hidden", "false");
    if (overlay) overlay.classList.add("on");
    document.documentElement.style.overflow = "hidden";
    var f = el.querySelector("button, a, input"); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeAll() {
    $$(".drawer.on, .filters.on").forEach(function (d) { d.classList.remove("on"); d.setAttribute("aria-hidden", "true"); });
    if (overlay) overlay.classList.remove("on");
    document.documentElement.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Carrinho ---------- */
  var cartDrawer = $("#cart-drawer");
  function cartFetch(url, body) {
    return fetch(url, {
      method: body ? "POST" : "GET",
      credentials: "same-origin",
      headers: body ? { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" } : { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.text().then(function (txt) {
        var j = null;
        try { j = txt ? JSON.parse(txt) : null; } catch (err) { j = null; }
        if (!r.ok) {
          var e = new Error((j && (j.description || j.message)) || ("Não foi possível atualizar o carrinho (erro " + r.status + ")."));
          e.status = r.status; throw e;
        }
        if (j === null) {
          // Resposta vazia ou fora do padrão: confirma lendo o carrinho de novo.
          if (url.indexOf(K.routes.cart + ".js") === 0) throw new Error("Não foi possível ler o carrinho (resposta " + r.status + " vazia).");
          return getCart();
        }
        return j;
      });
    });
  }
  var getCart = function () { return cartFetch(K.routes.cart + ".js"); };
  function updateCount(cart) {
    $$("[data-cart-count]").forEach(function (b) { b.textContent = cart.item_count; b.hidden = !cart.item_count; });
    var l = $("[data-cart-count-label]"); if (l) l.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";
  }
  function propsHTML(props) {
    if (!props) return "";
    return Object.keys(props).filter(function (k) { return k.charAt(0) !== "_" && props[k]; })
      .map(function (k) { return '<div class="props">' + esc(k) + ": " + esc(props[k]) + "</div>"; }).join("");
  }
  function renderCart(cart) {
    updateCount(cart);
    var body = cartDrawer && cartDrawer.querySelector("[data-cart-body]");
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="drawer-bd"><div class="empty" style="border:0"><h3>Seu carrinho está vazio</h3><p>Escolha uma camisa, selecione o tamanho e ela aparece aqui.</p><a class="btn btn-ink" href="' + (K.routes.root || "/") + 'collections/all">Ver camisas</a></div></div>';
      return;
    }
    var thr = K.freeShipping || 0, left = Math.max(0, thr - cart.total_price), pct = thr ? Math.min(100, cart.total_price / thr * 100) : 0;
    var lines = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=200") + '" alt="" loading="lazy">' : "";
      var variant = it.product_has_only_default_variant ? "" : '<div class="line-meta">' + esc((it.variant_title || "").replace(/ \/ /g, " · ")) + "</div>";
      var disc = (it.line_level_discount_allocations || []).map(function (d) { return '<div class="disc-line">' + esc(d.discount_application.title) + " (−" + formatMoney(d.amount) + ")</div>"; }).join("");
      var price = it.original_line_price > it.final_line_price
        ? '<span style="text-align:right"><b class="num">' + formatMoney(it.final_line_price) + '</b><br><s class="muted" style="font-size:13px">' + formatMoney(it.original_line_price) + "</s></span>"
        : '<b class="num">' + formatMoney(it.final_line_price) + "</b>";
      return '<div class="line"><a class="th" href="' + esc(it.url) + '">' + img + "</a>" +
        '<div style="min-width:0"><a class="line-name" href="' + esc(it.url) + '">' + esc(it.product_title) + "</a>" + variant + propsHTML(it.properties) + disc +
        '<div style="display:flex;gap:12px;align-items:center;margin-top:10px">' + (isAddon(it) ? '<span class="muted" style="font-size:13px">Qtd. ' + it.quantity + " · acompanha a camisa</span>" : '<div class="qty sm"><button type="button" data-act="cqty" data-line="' + (i + 1) + '" data-v="-1" aria-label="Diminuir">−</button><span>' + it.quantity + '</span><button type="button" data-act="cqty" data-line="' + (i + 1) + '" data-v="1" aria-label="Aumentar">+</button></div>') + '<button type="button" class="rm" data-act="crm" data-line="' + (i + 1) + '">Remover</button></div></div>' +
        '<div class="line-side">' + price + "</div></div>";
    }).join("");
    var discounts = (cart.cart_level_discount_applications || []).map(function (d) { return '<div class="disc"><span>' + esc(d.title) + "</span><span>−" + formatMoney(d.total_allocated_amount) + "</span></div>"; }).join("");
    body.innerHTML =
      '<div class="drawer-bd">' +
      (thr ? '<div class="ship-bar">' + (left > 0 ? "<span>Faltam <b>" + formatMoney(left) + "</b> para o frete grátis</span>" : "<span><b>Frete grátis</b> garantido neste pedido</span>") + '<div class="track"><div class="fill" style="width:' + pct + '%"></div></div></div>' : "") +
      lines + "</div>" +
      '<div class="drawer-ft"><div class="totals"><div><span>Subtotal</span><span>' + formatMoney(cart.items_subtotal_price) + "</span></div>" + discounts +
      '<div class="grand"><span>Total</span><span>' + formatMoney(cart.total_price) + "</span></div></div>" +
      couponHTML(cart) +
      '<p class="muted" style="font-size:13px">O frete é calculado na próxima etapa.</p>' +
      '<form action="' + esc(K.routes.cart) + '" method="post"><button class="btn btn-primary btn-block" type="submit" name="checkout">Finalizar compra</button></form>' +
      '<a class="btn btn-ghost btn-block" href="' + esc(K.routes.cart) + '">Ver carrinho e calcular frete</a></div>';
  }
  /* ---------- Personalização e patch sempre ligados à camisa ---------- */
  function isAddon(it) { var p = it.properties || {}; return it.variant_id === K.persVariantId || it.variant_id === K.patchVariantId || !!p["Para"]; }
  function addonKind(it) { var p = it.properties || {}; return (it.variant_id === K.patchVariantId || (p["Patch"] && !p["Nome"] && !p["Número"])) ? "patch" : "pers"; }
  function postJSON(url, body) { return cartFetch(url, body); }
  // Confere o carrinho: tira nome/número/patch da camisa se a linha paga sumiu, remove linhas pagas sem camisa e iguala as quantidades.
  function reconcile(cart) {
    var shirts = cart.items.filter(function (i) { return !isAddon(i); }), addons = cart.items.filter(isAddon);
    var updates = {}, nUpd = 0, strips = [];
    addons.forEach(function (a) {
      var ref = a.properties && a.properties._ref;
      var s = ref && shirts.filter(function (x) { return x.properties && x.properties._ref === ref; })[0];
      if (!s) { updates[a.key] = 0; nUpd++; }
      else if (a.quantity !== s.quantity) { updates[a.key] = s.quantity; nUpd++; }
    });
    shirts.forEach(function (s) {
      var p = s.properties || {}, ref = p._ref;
      var mine = addons.filter(function (a) { return ref && a.properties && a.properties._ref === ref; });
      var hasPers = mine.some(function (a) { return addonKind(a) === "pers"; }), hasPatch = mine.some(function (a) { return addonKind(a) === "patch"; });
      var np = {}, dirty = false;
      Object.keys(p).forEach(function (k) {
        if ((k === "Nome" || k === "Número") && !hasPers) { dirty = true; return; }
        if (k === "Patch" && !hasPatch) { dirty = true; return; }
        np[k] = p[k];
      });
      if (dirty) { if (!hasPers && !hasPatch) delete np._ref; strips.push({ id: s.key, quantity: s.quantity, properties: np }); }
    });
    if (!nUpd && !strips.length) return Promise.resolve({ cart: cart, changed: false });
    var chain = nUpd ? postJSON(K.routes.cartUpdate + ".js", { updates: updates }) : Promise.resolve();
    // Se não der para limpar a camisa (ex.: estoque esgotado), a camisa sai do carrinho para não ir personalizada sem pagar.
    strips.forEach(function (s) {
      chain = chain.then(function () {
        return postJSON(K.routes.cartChange + ".js", s).catch(function () {
          return postJSON(K.routes.cartChange + ".js", { id: s.id, quantity: 0 }).catch(function () {});
        });
      });
    });
    return chain.then(getCart).then(function (c) { return { cart: c, changed: true }; });
  }
  function getCartChecked() { return getCart().then(reconcile).then(function (r) { return r.cart; }); }
  /* ---------- Cupom de desconto ---------- */
  function couponHTML(cart) {
    var tags = (cart.discount_codes || []).map(function (d) {
      return '<div class="coupon-tag' + (d.applicable ? "" : " off") + '"><span>' + esc(d.code) + (d.applicable ? "" : " · não vale para este carrinho") + '</span><button type="button" data-coupon-remove="' + esc(d.code) + '" aria-label="Remover cupom">×</button></div>';
    }).join("");
    return '<div class="coupon" data-coupon><label class="coupon-lbl">Cupom de desconto</label><div class="coupon-row"><input class="input" data-coupon-input placeholder="Digite seu cupom" autocomplete="off" style="text-transform:uppercase"><button class="btn btn-ink btn-sm" type="button" data-coupon-apply>Aplicar</button></div><p class="coupon-msg" data-coupon-msg></p>' + tags + "</div>";
  }
  function couponDone(cart, box, msg, ok) {
    if ($("[data-cart-form]")) { location.reload(); return; }
    renderCart(cart);
    var m = cartDrawer && cartDrawer.querySelector("[data-coupon-msg]");
    if (m && msg) { m.textContent = msg; m.className = "coupon-msg " + (ok ? "ok" : "bad"); }
  }
  function setCodes(codes) { return cartFetch(K.routes.cartUpdate + ".js", { discount: codes.join(",") }); }
  function applyCoupon(box) {
    var input = box.querySelector("[data-coupon-input]"), msg = box.querySelector("[data-coupon-msg]");
    var code = (input.value || "").trim().toUpperCase();
    if (!code) { msg.textContent = "Digite um cupom."; msg.className = "coupon-msg bad"; input.focus(); return; }
    msg.textContent = "Aplicando…"; msg.className = "coupon-msg";
    getCart().then(function (c) {
      var codes = (c.discount_codes || []).map(function (d) { return d.code; }).filter(function (x) { return x.toUpperCase() !== code; });
      codes.push(code);
      return setCodes(codes);
    }).then(function (cart) {
      var d = (cart.discount_codes || []).filter(function (x) { return x.code.toUpperCase() === code; })[0];
      if (d && d.applicable) { couponDone(cart, box, "Cupom " + code + " aplicado!", true); return; }
      var others = (cart.discount_codes || []).filter(function (x) { return x.code.toUpperCase() !== code; }).map(function (x) { return x.code; });
      return setCodes(others).then(function (c2) {
        if ($("[data-cart-form]")) { msg.textContent = "Cupom inválido ou não vale para estes produtos."; msg.className = "coupon-msg bad"; return; }
        couponDone(c2, box, "Cupom inválido ou não vale para estes produtos.", false);
      });
    }).catch(function () {
      // Plano B: link de desconto da Shopify, que aplica o cupom e volta para o carrinho.
      location.href = (K.routes.root || "/") + "discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(K.routes.cart);
    });
  }
  document.addEventListener("click", function (e) {
    var ap = e.target.closest("[data-coupon-apply]");
    if (ap) { e.preventDefault(); applyCoupon(ap.closest("[data-coupon]")); return; }
    var rm = e.target.closest("[data-coupon-remove]");
    if (rm) {
      e.preventDefault();
      var code = rm.getAttribute("data-coupon-remove").toUpperCase();
      getCart().then(function (c) {
        return setCodes((c.discount_codes || []).map(function (d) { return d.code; }).filter(function (x) { return x.toUpperCase() !== code; }));
      }).then(function (cart) { couponDone(cart, null, "Cupom removido.", true); }).catch(function () { toast("Não foi possível remover o cupom agora.", true); });
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.matches && e.target.matches("[data-coupon-input]")) { e.preventDefault(); applyCoupon(e.target.closest("[data-coupon]")); }
  });

  // Estrelinhas douradas: andam devagar exatamente em cima da moldura arredondada (só com o mouse em cima)
  (function () {
    var R = 20, LAP = [70000, 70000, 90000], DIR = [1, 1, -1];
    function pointAt(w, h, d) {
      var r = Math.min(R, w / 2, h / 2), sw = w - 2 * r, sh = h - 2 * r, q = Math.PI * r / 2;
      var segs = [sw, q, sh, q, sw, q, sh, q], total = 0, i;
      for (i = 0; i < 8; i++) total += segs[i];
      d = ((d % total) + total) % total;
      for (i = 0; i < 8; i++) { if (d <= segs[i]) break; d -= segs[i]; }
      var a;
      switch (i) {
        case 0: return [r + d, 0];
        case 1: a = -Math.PI / 2 + d / r; return [w - r + r * Math.cos(a), r + r * Math.sin(a)];
        case 2: return [w, r + d];
        case 3: a = d / r; return [w - r + r * Math.cos(a), h - r + r * Math.sin(a)];
        case 4: return [w - r - d, h];
        case 5: a = Math.PI / 2 + d / r; return [r + r * Math.cos(a), h - r + r * Math.sin(a)];
        case 6: return [0, h - r - d];
        default: a = Math.PI + d / r; return [r + r * Math.cos(a), r + r * Math.sin(a)];
      }
    }
    function setup(card) {
      var stars = $$(".card-sp", card), phase = stars.map(function () { return Math.random(); }), raf = 0, last = 0;
      function frame(t) {
        var dt = last ? Math.min(t - last, 100) : 0; last = t;
        var w = card.offsetWidth, h = card.offsetHeight, r = Math.min(R, w / 2, h / 2);
        var per = 2 * (w + h - 4 * r) + 2 * Math.PI * r;
        stars.forEach(function (s, i) {
          phase[i] = (phase[i] + DIR[i] * dt / LAP[i] + 1) % 1;
          var p = pointAt(w, h, phase[i] * per);
          s.style.transform = "translate(" + p[0].toFixed(1) + "px," + p[1].toFixed(1) + "px)";
        });
        raf = requestAnimationFrame(frame);
      }
      card._kbStart = function () { if (raf) return; last = 0; frame(0); card.classList.add("kb-on"); };
      card._kbStop = function () { card.classList.remove("kb-on"); if (raf) cancelAnimationFrame(raf); raf = 0; };
      card.addEventListener("mouseleave", card._kbStop);
      card.addEventListener("focusout", function (e) { if (!card.contains(e.relatedTarget)) card._kbStop(); });
    }
    function enter(e) {
      var card = e.target.closest && e.target.closest(".card.kb-frame");
      if (!card) return;
      if (!card._kbStart) setup(card);
      card._kbStart();
    }
    // Delegado no documento: funciona também nos cards que carregam depois (filtros, relacionados)
    document.addEventListener("mouseover", enter);
    document.addEventListener("focusin", enter);
  })();
  function openCart() {
    if (!cartDrawer) { location.href = K.routes.cart; return; }
    openDrawer(cartDrawer);
    getCartChecked().then(renderCart).catch(function () { location.href = K.routes.cart; });
  }
  // Quando muda uma camisa com personalização, ajusta junto a linha da personalização (mesma _ref).
  function changeLine(line, qty) {
    if (cartDrawer) cartDrawer.classList.add("busy");
    return getCart().then(function (cart) {
      var item = cart.items[line - 1]; if (!item) return cart;
      var ref = item.properties && item.properties._ref;
      var updates = {}; updates[item.key] = qty;
      if (ref) cart.items.forEach(function (o) {
        if (o.key !== item.key && o.properties && o.properties._ref === ref) {
          var addon = o.variant_id === K.persVariantId || o.variant_id === K.patchVariantId; var isAddon = item.variant_id === K.persVariantId || item.variant_id === K.patchVariantId;
          if (addon && !isAddon) updates[o.key] = qty;
        }
      });
      return cartFetch(K.routes.cartUpdate + ".js", { updates: updates });
    }).then(reconcile).then(function (r) { renderCart(r.cart); return r.cart; })
      .catch(function (e) { if (cartDrawer && cartDrawer.classList.contains("on")) toast(e.message, true); return null; })
      .finally(function () { if (cartDrawer) cartDrawer.classList.remove("busy"); });
  }

  /* ---------- Página de produto ---------- */
  function businessDays(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  var shortDate = function (d) { return d.toLocaleDateString("pt-BR", { weekday: "short", day: "numeric", month: "short" }); };

  function backShirt(name, num) {
    name = String(name || "").toUpperCase().slice(0, 10); num = String(num || "").slice(0, 2);
    var body = "M62,18 L84,10 Q100,21 116,10 L138,18 L180,42 L164,84 L146,76 L146,204 Q100,212 54,204 L54,76 L36,84 L20,42 Z";
    var F = 'font-family="Big Shoulders Display, Arial Narrow, sans-serif"';
    return '<svg viewBox="0 0 200 220" role="img" aria-label="Prévia das costas da camisa"><path d="' + body + '" fill="#141414" stroke="#000" stroke-opacity=".3"/>' +
      '<path d="M84,10 Q100,17 116,10" fill="none" stroke="#EDEDED" stroke-width="5" stroke-linecap="round"/>' +
      (name ? '<text x="100" y="56" text-anchor="middle" ' + F + ' font-weight="800" font-size="' + (name.length > 9 ? 12 : 14) + '" letter-spacing="2" fill="#EDEDED">' + esc(name) + "</text>" : "") +
      (num ? '<text x="100" y="150" text-anchor="middle" ' + F + ' font-weight="900" font-size="84" fill="#EDEDED">' + esc(num) + "</text>" : "") + "</svg>";
  }

  // Plano B: envia pelo formulário normal da Shopify (POST /cart/add), que sempre funciona e leva ao carrinho.
  function nativeAdd(items) {
    var f = document.createElement("form");
    f.method = "post"; f.action = K.routes.cartAdd; f.acceptCharset = "UTF-8"; f.style.display = "none";
    function field(n, v) { var i = document.createElement("input"); i.type = "hidden"; i.name = n; i.value = v; f.appendChild(i); }
    field("form_type", "product"); field("utf8", "\u2713");
    items.forEach(function (it, i) {
      field("items[" + i + "][id]", it.id);
      field("items[" + i + "][quantity]", it.quantity);
      Object.keys(it.properties || {}).forEach(function (k) { field("items[" + i + "][properties][" + k + "]", it.properties[k]); });
    });
    field("return_to", K.routes.cart);
    document.body.appendChild(f); f.submit();
  }

  function initProduct(root) {
    var form = root.querySelector("[data-product-form]");
    var pj = $("[data-product-json]"), pc = $("[data-product-config]");
    if (!form || !pj) return;
    var product = JSON.parse(pj.textContent), cfg = pc ? JSON.parse(pc.textContent) : {};
    var select = form.querySelector("[data-variant-select]");
    var addBtn = form.querySelector("[data-add]"), addLabel = form.querySelector("[data-add-label]");
    var msg = form.querySelector("[data-variant-msg]");
    var persToggle = form.querySelector("[data-pers-toggle]");
    var persFields = form.querySelector("[data-pers-fields]");
    var patchToggle = form.querySelector("[data-patch-toggle]"), patchFields = form.querySelector("[data-patch-fields]"), patchType = form.querySelector("[data-patch-type]");
    function patchOn() { return !!(patchToggle && patchToggle.checked); }
    var pName = form.querySelector("[data-pers-name]"), pNum = form.querySelector("[data-pers-num]"), pErr = form.querySelector("[data-pers-err]"), pArt = form.querySelector("[data-pers-art]");
    var qtyInput = form.querySelector("[data-qty]"), qtyLabel = form.querySelector("[data-qty-label]");
    var current = product.variants.find(function (v) { return String(v.id) === select.value; }) || product.variants[0];
    var nOpts = product.options.length;

    function selected() { var out = []; for (var i = 0; i < nOpts; i++) { var r = form.querySelector('input[name="option-' + i + '"]:checked'); out.push(r ? r.value : null); } return out; }
    function findVariant(opts) {
      var m = product.variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; }); });
      return m.find(function (v) { return v.available; }) || m[0];
    }
    function persOn() { return !!(persToggle && persToggle.checked && (pName.value.trim() || pNum.value.trim())); }

    function showMedia(id) {
      $$("[data-media-slide]", root).forEach(function (s) { s.hidden = String(s.dataset.mediaSlide) !== String(id); });
      $$('[data-act="media"]', root).forEach(function (b) { var on = String(b.dataset.media) === String(id); b.classList.toggle("on", on); b.setAttribute("aria-selected", on); });
    }
    function update(fromUser) {
      var opts = selected();
      var v = findVariant(opts);
      // marca valores sem estoque considerando as outras escolhas
      for (var i = 0; i < nOpts; i++) {
        $$('[data-option-value^="' + i + '|"]', form).forEach(function (lab) {
          var val = lab.getAttribute("data-option-value").split("|").slice(1).join("|");
          var test = opts.slice(); test[i] = val;
          var tv = findVariant(test);
          lab.classList.toggle("na", !tv || !tv.available);
          var hint = lab.querySelector("[data-option-hint]");
          if (hint && tv) hint.textContent = formatMoney(tv.price) + (tv.available ? "" : " · esgotado");
        });
        var ol = form.querySelector('[data-option-label="' + i + '"]'); if (ol) { if (opts[i]) ol.textContent = opts[i]; else ol.innerHTML = '<span class="muted">escolha</span>'; }
      }
      if (!v) { msg.textContent = "Esta combinação não está disponível."; addBtn.disabled = true; addLabel.textContent = "Indisponível"; return; }
      msg.textContent = "";
      current = v; select.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? "Adicionar ao carrinho" : "Esgotado";
      var extra = (persOn() ? (K.persPrice || 0) : 0) + (patchOn() ? (K.patchPrice || 0) : 0);
      var priceWrap = root.querySelector("[data-price-wrap]");
      if (priceWrap) priceWrap.innerHTML = '<span class="price">' + (v.compare_at_price > v.price
        ? '<span class="sale">' + formatMoney(v.price + extra) + "</span><s>" + formatMoney(v.compare_at_price + extra) + "</s>"
        : "<span>" + formatMoney(v.price + extra) + "</span>") + (extra ? ' <span class="muted" style="font-size:14px;font-weight:500">com ' + (persOn() && patchOn() ? "personalização e patch" : persOn() ? "personalização" : "patch") + "</span>" : "") + "</span>";
      var inst = root.querySelector("[data-installments]");
      if (inst) {
        var total = v.price + extra, n = cfg.installmentsMax || 1;
        inst.textContent = (n > 1 && total >= (cfg.installmentMin || 0)) ? "ou em até " + n + "x no cartão de crédito" : "";
      }
      if (fromUser && v.featured_media) showMedia(v.featured_media.id);
      if (fromUser && history.replaceState) { var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState({}, "", u.toString()); }
      var est = $("[data-ship-est]");
      if (est) { var add = persToggle && persToggle.checked ? (cfg.persDays || 0) : 0; est.textContent = "Chega entre " + shortDate(businessDays((K.shipMin || 7) + add)) + " e " + shortDate(businessDays((K.shipMax || 12) + add)); }
    }
    var sizeErr = form.querySelector("[data-size-err]");
    function missingSize() {
      var groups = {};
      $$("[data-size-required]", form).forEach(function (r) { groups[r.name] = groups[r.name] || !!form.querySelector('input[name="' + r.name + '"]:checked'); });
      if ($("[data-prop-size]", form)) groups["kb-size"] = !!form.querySelector('input[name="kb-size"]:checked');
      for (var g in groups) if (!groups[g]) return g;
      return null;
    }
    form.addEventListener("change", function (e) {
      if (e.target.matches("[data-option]")) update(true);
      if (e.target.matches("[data-prop-size]")) { var sl = form.querySelector("[data-prop-size-label]"); if (sl) sl.textContent = e.target.value; }
      if (e.target.matches("[data-option],[data-prop-size]") && sizeErr && !missingSize()) { sizeErr.textContent = ""; }
    });
    root.addEventListener("click", function (e) {
      var m = e.target.closest('[data-act="media"]'); if (m) { showMedia(m.dataset.media); return; }
      var q = e.target.closest('[data-act="qty"]');
      if (q) { var n = Math.max(1, Math.min(20, (parseInt(qtyInput.value, 10) || 1) + parseInt(q.dataset.v, 10))); qtyInput.value = n; qtyLabel.textContent = n; }
    });

    function drawPers() { if (pArt) pArt.innerHTML = backShirt(pName.value, pNum.value); }
    if (patchToggle) patchToggle.addEventListener("change", function () { if (patchFields) patchFields.hidden = !patchToggle.checked; update(false); });
    if (persToggle) {
      persToggle.addEventListener("change", function () {
        persFields.hidden = !persToggle.checked;
        pName.disabled = pNum.disabled = !persToggle.checked;
        if (persToggle.checked) { drawPers(); pName.focus(); } else { pErr.textContent = ""; }
        update(false);
      });
      pName.addEventListener("input", function () { pName.value = pName.value.toUpperCase().replace(/[^A-ZÀ-Ú .'-]/g, "").slice(0, 10); drawPers(); update(false); });
      pNum.addEventListener("input", function () { pNum.value = digits(pNum.value).slice(0, 2); drawPers(); update(false); });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var miss = missingSize();
      if (miss) {
        if (sizeErr) sizeErr.textContent = "Escolha um tamanho para adicionar ao carrinho.";
        var first = form.querySelector('input[name="' + miss + '"]');
        if (first) { var lab = form.querySelector('label[for="' + first.id + '"]'); (lab || first).scrollIntoView({ behavior: "smooth", block: "center" }); }
        return;
      }
      if (!current || !current.available) return;
      var qty = parseInt(qtyInput.value, 10) || 1;
      var props = {};
      var ps = form.querySelector('input[name="kb-size"]:checked');
      if (ps) props["Tamanho"] = ps.value;
      if (K.notice) props[K.noticeLabel || "IMPORTANTE"] = K.notice;
      var extras = [], ref = null;
      function getRef() { if (!ref) ref = Date.now().toString(36) + Math.random().toString(36).slice(2, 6); return ref; }
      var forLabel = product.title + (current.title && current.title !== "Default Title" ? " (" + current.title + ")" : (ps ? " (" + ps.value + ")" : ""));
      if (persToggle && persToggle.checked) {
        var nm = pName.value.trim(), nb = pNum.value.trim();
        if (!nm && !nb) { pErr.textContent = "Informe um nome, um número ou os dois."; pName.focus(); return; }
        pErr.textContent = "";
        if (nm) props["Nome"] = nm;
        if (nb) props["Número"] = nb;
        props._ref = getRef();
        if (K.persVariantId) {
          var p2 = { "Para": forLabel, _ref: getRef() };
          if (nm) p2["Nome"] = nm; if (nb) p2["Número"] = nb;
          extras.push({ id: K.persVariantId, quantity: qty, properties: p2 });
        }
      }
      if (patchOn()) {
        var pt = patchType ? patchType.value : "Sim";
        props["Patch"] = pt;
        props._ref = getRef();
        if (K.patchVariantId) extras.push({ id: K.patchVariantId, quantity: qty, properties: { "Para": forLabel, "Patch": pt, _ref: getRef() } });
      }
      var items = [{ id: current.id, quantity: qty, properties: props }].concat(extras);
      addBtn.disabled = true; addLabel.textContent = "Adicionando…";
      cartFetch(K.routes.cartAdd + ".js", { items: items })
        .then(function () {
          if (K.cartType === "page") { location.href = K.routes.cart; return; }
          openCart();
        })
        .catch(function () { nativeAdd(items); })
        .finally(function () { addBtn.disabled = !current.available; addLabel.textContent = current.available ? "Adicionar ao carrinho" : "Esgotado"; });
    });
    update(false);
  }

  /* ---------- Busca com sugestões ---------- */
  function initSearch() {
    var form = $("[data-search]"); if (!form) return;
    var input = form.querySelector('input[name="q"]'), box = form.querySelector("#suggest");
    var timer, seq = 0, idx = -1;
    function close() { box.hidden = true; idx = -1; }
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        var my = ++seq;
        fetch(K.routes.predictive + ".json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (my !== seq) return;
            var list = (j.resources && j.resources.results && j.resources.results.products) || [];
            box.innerHTML = list.length
              ? list.map(function (p) {
                  var img = p.image ? '<img src="' + esc(p.image) + '" alt="" style="width:44px;height:44px;object-fit:cover;border-radius:8px">' : "";
                  var cents = Math.round(parseFloat(p.price) * 100);
                  return '<a href="' + esc(p.url) + '"><span class="th">' + img + '</span><span style="min-width:0">' + esc(p.title) + "<small>" + esc(p.vendor || "") + '</small></span><b class="num" style="font-size:14px">' + formatMoney(cents) + "</b></a>";
                }).join("") + '<a class="all" href="' + esc(K.routes.search) + "?q=" + encodeURIComponent(q) + '&type=product">Ver todos os resultados para “' + esc(q) + "”</a>"
              : '<p class="muted" style="padding:14px;font-size:14px">Nenhuma camisa para “' + esc(q) + "”. Tente o nome do clube ou a temporada.</p>";
            box.hidden = false;
          }).catch(close);
      }, 220);
    });
    input.addEventListener("keydown", function (e) {
      var items = $$("a", box);
      if (box.hidden || !items.length) return;
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        idx = (idx + (e.key === "ArrowDown" ? 1 : -1) + items.length) % items.length;
        items.forEach(function (a, i) { a.classList.toggle("hl", i === idx); });
      } else if (e.key === "Enter" && idx >= 0) { e.preventDefault(); location.href = items[idx].href; }
    });
    document.addEventListener("click", function (e) { if (!form.contains(e.target)) close(); });
  }

  /* ---------- Filtros e ordenação ---------- */
  function initFacets() {
    var f = $("[data-facets]");
    if (f) {
      f.addEventListener("change", function (e) { if (e.target.matches("[data-autosubmit]")) submitFacets(f); });
      f.addEventListener("submit", function (e) { e.preventDefault(); submitFacets(f); });
    }
    var sort = $("[data-sort]");
    if (sort) sort.addEventListener("change", function () {
      var u = new URL(location.href); u.searchParams.set("sort_by", sort.value); u.searchParams.delete("page"); location.href = u.toString();
    });
  }
  function submitFacets(f) {
    $$("[data-price]", f).forEach(function (i) {
      var v = i.value.trim();
      if (!v) { i.disabled = true; return; }
      if (v.indexOf(",") > -1) v = v.replace(/\./g, "").replace(",", ".");
      i.value = v.replace(/[^\d.]/g, "");
    });
    var data = new URLSearchParams(new FormData(f));
    var u = new URL(location.href);
    u.search = data.toString();
    location.href = u.toString();
  }

  /* ---------- Página do carrinho: atualização e frete por CEP ---------- */
  // Antes de ir para o pagamento, confere o carrinho. Se algo foi corrigido, mostra o carrinho atualizado.
  document.addEventListener("submit", function (e) {
    var f = e.target, sub = e.submitter;
    if (!sub || sub.name !== "checkout" || f.dataset.checked === "1") return;
    e.preventDefault();
    sub.disabled = true;
    getCart().then(reconcile).then(function (r) {
      if (r.changed) { toast("Atualizamos seu carrinho: a personalização ou o patch removido saiu também da camisa.", false); setTimeout(function () { location.href = K.routes.cart; }, 900); return; }
      var h = document.createElement("input"); h.type = "hidden"; h.name = "checkout"; h.value = "1"; f.appendChild(h);
      f.dataset.checked = "1"; f.submit();
    }).catch(function () { f.dataset.checked = "1"; var h = document.createElement("input"); h.type = "hidden"; h.name = "checkout"; h.value = "1"; f.appendChild(h); f.submit(); });
  });
  function initCartPage() {
    var form = $("[data-cart-form]"); if (!form) return;
    getCart().then(reconcile).then(function (r) { if (r.changed) location.reload(); }).catch(function () {});
    form.addEventListener("change", function (e) { if (e.target.matches("[data-autosubmit]")) { var h = document.createElement("input"); h.type = "hidden"; h.name = "update"; h.value = "1"; form.appendChild(h); form.submit(); } });
    var box = $("[data-cep-box]"); if (!box) return;
    var input = box.querySelector("[data-cep-input]"), status = box.querySelector("[data-cep-status]"), rates = box.querySelector("[data-rates]");
    input.addEventListener("input", function () { var d = digits(input.value).slice(0, 8); input.value = d.length > 5 ? d.slice(0, 5) + "-" + d.slice(5) : d; if (d.length === 8) calc(); });
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); calc(); } });
    box.addEventListener("click", function (e) { if (e.target.closest('[data-act="calc-ship"]')) calc(); });
    var busy = false;
    function say(t, cls) { status.textContent = t; status.className = "cep-status" + (cls ? " " + cls : ""); }
    function calc() {
      var cep = digits(input.value);
      if (cep.length !== 8) { say("Informe um CEP com 8 números.", "bad"); return; }
      if (busy) return; busy = true; rates.innerHTML = ""; say("Buscando endereço…");
      fetch("https://viacep.com.br/ws/" + cep + "/json/")
        .then(function (r) { return r.json(); })
        .then(function (a) {
          if (a.erro) { say("CEP não encontrado. Confira os números.", "bad"); busy = false; return; }
          say([a.logradouro, a.bairro].filter(Boolean).join(", ") + (a.logradouro || a.bairro ? " · " : "") + a.localidade + "/" + a.uf, "ok");
          return shippingRates(cep.slice(0, 5) + "-" + cep.slice(5), a.uf);
        })
        .catch(function () { say("Não conseguimos consultar agora. O frete aparece no checkout.", "bad"); })
        .finally(function () { busy = false; });
    }
    function shippingRates(cep, uf) {
      var q = "shipping_address[zip]=" + encodeURIComponent(cep) + "&shipping_address[country]=Brazil&shipping_address[province]=" + encodeURIComponent(uf);
      rates.innerHTML = '<span class="muted">Calculando frete…</span>';
      return fetch(K.routes.cart + "/prepare_shipping_rates.json?" + q, { method: "POST" })
        .then(function () { return poll(q, 0); })
        .then(function (list) {
          if (!list || !list.length) { rates.innerHTML = '<span class="muted">Não encontramos opções de entrega para este CEP. Confira no checkout.</span>'; return; }
          rates.innerHTML = list.map(function (r) {
            var cents = Math.round(parseFloat(r.price) * 100);
            var days = r.delivery_days && r.delivery_days.length ? " · " + r.delivery_days[0] + (r.delivery_days[1] && r.delivery_days[1] !== r.delivery_days[0] ? " a " + r.delivery_days[1] : "") + " dias úteis" : "";
            return "<div><span>" + esc(r.name) + '<span class="muted">' + esc(days) + "</span></span><b>" + (cents ? formatMoney(cents) : "Grátis") + "</b></div>";
          }).join("");
        })
        .catch(function () { rates.innerHTML = '<span class="muted">O valor do frete aparece no checkout.</span>'; });
    }
    function poll(q, n) {
      return fetch(K.routes.cart + "/async_shipping_rates.json?" + q).then(function (r) {
        if (r.status === 202 || r.status === 204) {
          if (n > 8) throw new Error("timeout");
          return new Promise(function (res) { setTimeout(res, 600); }).then(function () { return poll(q, n + 1); });
        }
        return r.json().then(function (j) {
          if (j && j.shipping_rates) return j.shipping_rates;
          if (j === null) { if (n > 8) throw new Error("timeout"); return new Promise(function (res) { setTimeout(res, 600); }).then(function () { return poll(q, n + 1); }); }
          throw new Error("no rates");
        });
      });
    }
  }

  /* ---------- Produtos relacionados ---------- */
  function initRecommendations() {
    var el = $("[data-recommendations]"); if (!el || el.children.length) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement("div"); tmp.innerHTML = html;
      var inner = tmp.querySelector("[data-recommendations]");
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  /* ---------- Cliques gerais ---------- */
  document.addEventListener("click", function (e) {
    var a = e.target.closest("[data-act]"); if (!a) return;
    var act = a.dataset.act;
    if (act === "close-all") { e.preventDefault(); closeAll(); }
    else if (act === "menu") { e.preventDefault(); openDrawer($("#menu-drawer")); }
    else if (act === "cart") { if (K.cartType === "page" || document.body.classList.contains("template-cart")) return; e.preventDefault(); openCart(); }
    else if (act === "filters-open") { e.preventDefault(); var f = $("#filters"); if (f) { f.classList.add("on"); if (overlay) overlay.classList.add("on"); } }
    else if (act === "filters-close") { e.preventDefault(); closeAll(); }
    else if (act === "size-guide") { e.preventDefault(); var d = $("#size-guide"); if (d && d.showModal) d.showModal(); }
    else if (act === "close-dialog") { e.preventDefault(); var dd = a.closest("dialog"); if (dd) dd.close(); }
    else if (act === "cqty") {
      e.preventDefault();
      var line = parseInt(a.dataset.line, 10), span = a.parentNode.querySelector("span");
      changeLine(line, Math.max(0, (parseInt(span.textContent, 10) || 1) + parseInt(a.dataset.v, 10)));
    }
    else if (act === "crm") { e.preventDefault(); changeLine(parseInt(a.dataset.line, 10), 0); }
  });
  // Remover na página do carrinho também remove a personalização ligada à camisa
  document.addEventListener("click", function (e) {
    var rm = e.target.closest("[data-remove-line]"), pq = e.target.closest("[data-page-qty]");
    if (!rm && !pq) return;
    e.preventDefault();
    var line = parseInt((rm || pq).dataset[rm ? "removeLine" : "pageQty"], 10);
    var el = rm || pq;
    changeLine(line, rm ? 0 : Math.max(0, parseInt(pq.dataset.to, 10) || 0)).then(function (cart) {
      if (cart) location.reload(); else if (el.href) location.href = el.href; // plano B: link normal da Shopify
    });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeAll(); var s = $("#suggest"); if (s) s.hidden = true; }
  });
  var sg = $("#size-guide");
  if (sg) sg.addEventListener("click", function (e) { if (e.target === sg) sg.close(); });

  /* ---------- Início ---------- */
  var pr = $("[data-product-root]"); if (pr) initProduct(pr);
  initSearch(); initFacets(); initCartPage(); initRecommendations();
})();
